import { followingSidebar } from '../utils/sidebar.utils.js';

const sidebar = document.querySelector('#sidebar');
const contentSticky = document.querySelector('#content-sticky');

if (sidebar && contentSticky && window.innerWidth >= 852) {
  followingSidebar({ sidebar, contentSticky });
}